import { reatomAsync, withDataAtom } from "@reatom/async";
import { atom, withAbort } from "@reatom/framework";
import { PageableRequestDto } from "definitions/exporter";
import { API } from "src/api.ts";
import { withDebounce, withIsLoadingAtom } from "src/common/pipes";
import { PAGINATION_DEFAULT_STATE } from "src/constants/pagination";

import { MAX_EXPORT_TASKS } from "../../ExportPage.constants";

export const exportTasksFilterAtom = atom<PageableRequestDto>(
  {
    page: PAGINATION_DEFAULT_STATE.page,
    // NOTE: Всегда загружаем минимум задач из MAX_EXPORT_TASKS
    limit: Math.max(PAGINATION_DEFAULT_STATE.pageSize, MAX_EXPORT_TASKS),
  },
  "exportTasksFilter",
);

export const getExportTasksRequest = reatomAsync(async (ctx) => {
  const data = ctx.get(exportTasksFilterAtom);
  return API.exporterQueueApi
    .exportControllerGetMyExportTasks(data, {
      signal: ctx.controller.signal,
    })
    .then((response) => response.data);
}, "getExportTasksRequest").pipe(
  withDataAtom({ data: [], totalItems: 0 }),
  withAbort(),
  withIsLoadingAtom(),
);

export const getExportTasksWithDebouncing = getExportTasksRequest.pipe(
  withDebounce(500),
);

exportTasksFilterAtom.onChange((ctx) => {
  getExportTasksWithDebouncing(ctx);
});
